module.exports = __webpack_public_path__ + "678eab8c1d7c829742224c374b42d571.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/banner_award_06_still.jpg
// module id = 632
// module chunks = 0